const businessProfile = () => import(/* webpackChunkName: "dinein setting" */ '@/components/settings/businessProfile')

export default {
    name: 'businessProfile',
    path: 'settings/businessProfile',
    redirect: '/settings/businessProfile/index',
    meta: {label: 'settings'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7]},
            component: businessProfile,
            props: true
        }
    ]
}
